import { render, staticRenderFns } from "./emtyRegion.vue?vue&type=template&id=4b8ad2a7&scoped=true"
import script from "./emtyRegion.vue?vue&type=script&lang=js"
export * from "./emtyRegion.vue?vue&type=script&lang=js"
import style0 from "./emtyRegion.vue?vue&type=style&index=0&id=4b8ad2a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ad2a7",
  null
  
)

export default component.exports